import { appUrl } from '../lib/appBase.js';
import { extTag } from '../lib/romUtils.js';

export function GameCard({ game, onSelect, onDownload, downloading, showCart = false, onPreview, ejsKey }) {
  const disabled = game.unsupported;
  const canPlay = !disabled && game.hasRom !== false && !!game.url;
  const thumbSrc = showCart
    ? game.cartThumbnail || game.thumbnail
    : game.thumbnail;
  const thumb = thumbSrc
    ? thumbSrc.startsWith('http')
      ? thumbSrc
      : appUrl(thumbSrc)
    : null;

  const handlePlay = () => {
    if (!canPlay) return;
    onSelect(game);
  };

  const notifyPreview = () => {
    if (onPreview) onPreview(game, ejsKey || game._ejsKey);
  };

  return (
    <div className={`rom-card-item${disabled ? ' rom-card-item--disabled' : ''}`}>
      <button
        type="button"
        className={`rom-card${showCart ? ' rom-card--cart' : ''}${!canPlay && !disabled ? ' rom-card--pending' : ''}${disabled ? ' rom-card--disabled' : ''}`}
        onClick={handlePlay}
        onMouseEnter={notifyPreview}
        onFocus={notifyPreview}
        disabled={disabled}
        title={
          disabled
            ? `${game.unsupportedLabel} não suportado`
            : canPlay
              ? `${game.title}${game.filename && game.filename !== game.title ? `\n${game.filename}` : ''}`
              : `${game.title}\nROM ainda não baixada — usa ↓`
        }
      >
        <div className="rom-card__media">
          {thumb ? (
            <img className={`rom-card__thumb${showCart ? ' rom-card__thumb--cart' : ''}`} src={thumb} alt="" loading="lazy" />
          ) : (
            <div className="rom-card__placeholder" aria-hidden="true">
              <span className="rom-card__ext">{game.filename ? extTag(game.filename) : '?'}</span>
            </div>
          )}
        </div>
        <span className="rom-card__title">{game.title}</span>
        {(game.year || game.overall != null || game.needsDownload || game.externalEmulator) && (
          <span className="rom-card__meta">
            {game.externalEmulator && <span className="rom-card__emu">{game.externalEmulator}</span>}
            {game.year && <span>{game.year}</span>}
            {game.overall != null && <span>★ {game.overall}</span>}
            {game.needsDownload && game.downloadSize && <span>{game.downloadSize}</span>}
          </span>
        )}
      </button>
      {game.needsDownload && onDownload && (
        <button
          type="button"
          className="rom-card-dl"
          onClick={() => onDownload(game)}
          disabled={downloading}
          title={downloading ? 'A baixar…' : 'Baixar ROM'}
          aria-label={`Baixar ROM: ${game.title}`}
        >
          {downloading ? '…' : '↓'}
        </button>
      )}
    </div>
  );
}
